import { LoopReducer } from "redux-loop";
import { ActionType, getType } from "typesafe-actions";
import {
  getEventAsync,
  createEventAsync,
  getDraggableForm,
  sendRegistrationAsync,
  postLinkForm,
  getLinkSuggestion,
} from "../events/eventReducer";
import { getAllEventsAsync } from "../events/listEvents/listEventsReducer";
import { loginAsync } from "../login/loginReducer";
import { LoadingState } from "../types/types";
import { getFormAsync } from "./formReducer";

const initialState: LoadingState = {
  loading: false,
};

type Action =
  | ActionType<typeof getFormAsync>
  | ActionType<typeof getEventAsync>
  | ActionType<typeof getAllEventsAsync>
  | ActionType<typeof loginAsync>
  | ActionType<typeof getDraggableForm>
  | ActionType<typeof createEventAsync>
  | ActionType<typeof sendRegistrationAsync>
  | ActionType<typeof postLinkForm>
  | ActionType<typeof getLinkSuggestion>;

export const loadingReducer: LoopReducer<LoadingState, Action> = (
  state: LoadingState = initialState,
  action: Action
): LoadingState => {
  switch (action.type) {
    case getType(getFormAsync.request):
      return { ...state, loading: true };
    case getType(postLinkForm.request):
      return { ...state, loading: true };
    case getType(loginAsync.request):
      return { ...state, loading: true };
    case getType(getAllEventsAsync.request):
      return { ...state, loading: true };
    case getType(getEventAsync.request):
      return { ...state, loading: true };
    case getType(getDraggableForm.request):
      return { ...state, loading: true };
    case getType(createEventAsync.request):
      return { ...state, loading: true };
    case getType(sendRegistrationAsync.request):
      return { ...state, loading: true };
    case getType(loginAsync.success):
      return { ...state, loading: false };
    case getType(loginAsync.failure):
      return { ...state, loading: false };
    case getType(getEventAsync.success):
      return { ...state, loading: false };
    case getType(getEventAsync.failure):
      return { ...state, loading: false };
    case getType(getAllEventsAsync.success):
      return { ...state, loading: false };
    case getType(getAllEventsAsync.failure):
      return { ...state, loading: false };
    case getType(getFormAsync.success):
      return { ...state, loading: false };
    case getType(getFormAsync.failure):
      return { ...state, loading: false };
    case getType(getDraggableForm.success):
      return { ...state, loading: false };
    case getType(getDraggableForm.failure):
      return { ...state, loading: false };
    case getType(createEventAsync.success):
      return { ...state, loading: false };
    case getType(createEventAsync.failure):
      return { ...state, loading: false };
    case getType(sendRegistrationAsync.success):
      return { ...state, loading: false };
    case getType(sendRegistrationAsync.failure):
      return { ...state, loading: false };
    case getType(postLinkForm.success):
      return { ...state, loading: false };
    case getType(postLinkForm.failure):
      return { ...state, loading: false };
    case getType(getLinkSuggestion.success):
      return { ...state, loading: false };
    case getType(getLinkSuggestion.failure):
      return { ...state, loading: false };
    default:
      return state;
  }
};
